/* global Office */

export default function makePromise(fn, context) {
  return (...args) =>
    new Promise((resolve, reject) => {
      const callback = result => {
        if (result.status === 'success' || result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value)
        } else {
          reject(result.error)
        }
      }
      args.push(callback)

      // Added optional chaining to check if fn is defined as it fails if function is not defined
      // This is to prevent runtime errors in case fn is not defined
      fn?.apply(context, args)
    })
}
